module.exports = __webpack_public_path__ + "static/media/draw.36a9c969.png";